import * as React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { useTheme } from "styled-components";

/**
 * Applies a max width, centring and default gutters.
 *
 * Use `<Gutters />` as the root element of a scene/page to lay things out consistently.
 *
 * You can also use multiple `<Gutters />` elements within a page to selectively allow content to
 * stretch to the edges.
 */

const Gutters: React.FC<{ style: BoxProps["style"] } & Omit<BoxProps, "style">> = ({
    style,
    ...props
}) => {
    const theme = useTheme();
    return (
        <Box
            maxWidth={theme.sizes.maxPageWidth}
            mx="auto"
            width="100%"
            pl={3}
            pr={3}
            style={{ display: "flex", justifyContent: "center", flexDirection: "column", ...style }}
            {...props}
        />
    );
};

export default Gutters;
